module.exports = __webpack_public_path__ + "img/close.626844cc.png";